import { t } from "@/i18n-js/instance";
import feature1 from "@circle-assets/images/features/courses-landing-v3/feature1.png";
import feature2 from "@circle-assets/images/features/courses-landing-v3/feature2.png";
import feature3 from "@circle-assets/images/features/courses-landing-v3/feature3.png";
import feature4 from "@circle-assets/images/features/courses-landing-v3/feature4.png";
import feature5 from "@circle-assets/images/features/courses-landing-v3/feature5.png";
import { CreateCourseButton } from "@circle-react/components/Courses/CoursesLandingPage/CreateCourseButton";
import { FeatureCard } from "@circle-react/components/Courses/CoursesLandingPage/FeatureCard";
import { FeatureImage } from "@circle-react/components/Courses/CoursesLandingPage/FeatureImage";
import { LandingFooter } from "@circle-react/components/Courses/CoursesLandingPage/Footer";
import { LandingHeader } from "@circle-react/components/Courses/CoursesLandingPage/Header";
import { StandardLayoutHeaderWithPortal } from "@circle-react/components/Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { SpaceHeaderTitleText } from "@circle-react/components/Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";

export const CoursesLandingPage = () => (
  <div className="bg-primary h-full">
    <StandardLayoutHeaderWithPortal
      leftContent={
        <SpaceHeaderTitleText>
          {t("courses.directory.title")}
        </SpaceHeaderTitleText>
      }
      rightContent={
        <CreateCourseButton variant="circle" large>
          {t("courses.landing_page_v3.cta")}
        </CreateCourseButton>
      }
    />
    <main className="mx-auto max-w-6xl">
      <div className="flex h-full w-full flex-col space-y-16 p-14">
        <LandingHeader />
        <div className="grid grid-flow-row-dense grid-cols-6 gap-6 lg:auto-rows-fr lg:grid-cols-12">
          <FeatureCard
            color="purple"
            icon="courses-community"
            feature="feature_1"
            iconSize={24}
          />
          <FeatureImage src={feature1} dataTestId="course-landing-hero" />
          <FeatureCard
            color="blue"
            icon="courses-video-hosting"
            iconSize={24}
            feature="feature_2"
          />
          <FeatureImage src={feature2} />
          <FeatureCard
            color="green"
            icon="courses-comments"
            feature="feature_3"
            iconSize={24}
          />
          <FeatureImage src={feature3} />
          <FeatureCard
            color="pink"
            icon="courses-paywalls"
            feature="feature_4"
            iconSize={24}
          />
          <FeatureImage src={feature4} />
          <FeatureCard
            color="lavender"
            icon="courses-dashboard"
            feature="feature_5"
            iconSize={24}
          />
          <FeatureImage src={feature5} />
        </div>
        <LandingFooter />
      </div>
    </main>
  </div>
);
